<div mat-dialog-title class="eForms-dialog-header">
  <h1 class="dialog-title">
    {{ getFirstLineErrorMessage() }}
  </h1>
  <button mat-mini-fab mat-dialog-close aria-label="Schließe Dialog" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="eForms-dialog-content">
  <div class="error-box">
    <div>
      <mat-icon class="icon danger"> error</mat-icon>
    </div>

    <div class="error-text-wrap">
      <p>{{ getFirstLineErrorMessage() }}</p>
      <p>Die Ursachen dafür finden Sie in den Fehlermeldungen in der Tabelle.</p>
      <p>
        Bei weiteren Problemen wenden Sie sich bitte mit allen hier gezeigten Informationen an den
        Helpdesk.
      </p>
    </div>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="data.schematronErrors">
      <ng-container matColumnDef="ruleId">
        <th mat-header-cell *matHeaderCellDef class="rule">Regel</th>
        <td mat-cell *matCellDef="let element" class="rule row">
          {{ element?.ruleId?.replace('rule|text|', '') }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="error-description">Fehlermeldung</th>
        <td mat-cell *matCellDef="let element" class="error-description row">
          {{ element.description }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let rowData; columns: displayedColumns"></tr>
    </table>
    <p class="date-and-version">
      <span>{{ buildVersion }}</span>
      <span>{{ buildNumber }}</span>
      <span>{{ dateAsText }}</span>
    </p>
  </div>
</div>
<mat-dialog-actions align="end" class="eForms-dialog-footer">
  <button mat-button mat-dialog-close (click)="dismissed()" class="eForms-button eForms-button--primary">Bearbeitung fortsetzen</button>
</mat-dialog-actions>
